import React from "react";
import { MessageCircle } from "lucide-react";
import { companyInfo } from "../mock";

const WhatsAppFloat = () => {
  return (
    <a
      href={`https://api.whatsapp.com/send?phone=${companyInfo.whatsapp}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#128C7E] shadow-lg flex items-center justify-center transition-colors animate-pulseSlow"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle size={26} className="text-white" />
    </a>
  );
};

export default WhatsAppFloat;
